"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFileSize = validateFileSize;
exports.getMaxAllowedSize = getMaxAllowedSize;
exports.validateFilename = validateFilename;
exports.validateS3Path = validateS3Path;
const mime_1 = require("./mime");
const s3_1 = require("./s3");
const DEFAULT_USAGE_LIMIT = 50 * 1024 * 1024;
function validateFileSize(fileSize, mimeType, usage) {
    const mimeTypeLimit = mime_1.ALLOWED_MIME_TYPES[mimeType].maxSize;
    if (fileSize > mimeTypeLimit) {
        return false;
    }
    if (usage) {
        const usageLimit = mime_1.USAGE_SIZE_LIMITS[usage] ?? mime_1.USAGE_SIZE_LIMITS.default ?? DEFAULT_USAGE_LIMIT;
        if (fileSize > usageLimit) {
            return false;
        }
    }
    return true;
}
function getMaxAllowedSize(mimeType, usage) {
    const mimeTypeLimit = mime_1.ALLOWED_MIME_TYPES[mimeType].maxSize;
    const usageLimit = usage
        ? (mime_1.USAGE_SIZE_LIMITS[usage] ?? mime_1.USAGE_SIZE_LIMITS.default ?? DEFAULT_USAGE_LIMIT)
        : (mime_1.USAGE_SIZE_LIMITS.default ?? DEFAULT_USAGE_LIMIT);
    return Math.min(mimeTypeLimit, usageLimit);
}
function validateFilename(filename) {
    if (!filename || filename.length === 0) {
        return { valid: false, error: 'Filename cannot be empty' };
    }
    if (filename.length > s3_1.S3_PATH_CONSTRAINTS.MAX_FILENAME_LENGTH) {
        return { valid: false, error: `Filename too long (max ${s3_1.S3_PATH_CONSTRAINTS.MAX_FILENAME_LENGTH} characters)` };
    }
    if (!s3_1.S3_PATH_CONSTRAINTS.FILENAME_PATTERN.test(filename)) {
        return { valid: false, error: 'Filename contains invalid characters (control characters and the path separators "/" and "\\" are not allowed)' };
    }
    return { valid: true };
}
function validateS3Path(path) {
    if (!path || path.length === 0) {
        return { valid: false, error: 'Path cannot be empty' };
    }
    if (path.length > s3_1.S3_PATH_CONSTRAINTS.MAX_PATH_LENGTH) {
        return { valid: false, error: `Path too long (max ${s3_1.S3_PATH_CONSTRAINTS.MAX_PATH_LENGTH} characters)` };
    }
    const hasValidPrefix = s3_1.S3_PATH_CONSTRAINTS.ALLOWED_PREFIXES.some((prefix) => path.startsWith(prefix));
    if (!hasValidPrefix) {
        return { valid: false, error: `Path must start with one of: ${s3_1.S3_PATH_CONSTRAINTS.ALLOWED_PREFIXES.join(', ')}` };
    }
    return { valid: true };
}
//# sourceMappingURL=validators.js.map